import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import LoadingScreen from './LoadingScreen';

const AdminRoute: React.FC = () => {
  const { user, isAdmin, loading, initialized } = useAuthStore();

  // Show loading screen only during initial load
  if (loading && !initialized) {
    return <LoadingScreen />;
  }

  // Redirect to home if not authenticated or not admin
  if ((!user || !isAdmin) && initialized) {
    return <Navigate to="/" replace />;
  }

  // Show children only when authenticated, admin and initialized
  if (user && isAdmin && initialized) {
    return <Outlet />;
  }

  // Show loading screen in any other case
  return <LoadingScreen />;
};

export default AdminRoute;